// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'user_nickname',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'hotel',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'order_detail',
    label: '',
    Object: 'value',
    width: '430'
  }, {
    prop: 'delivery_detail',
    label: '',
    Object: 'value',
    width: '430'
  }, {
    prop: 'status',
    back: true,
    label: '',
    Object: 'value',
    width: '120'
  }],
  order_information: [{
    prop: 'status',
    span: 4,
    back: true
  }, {
    prop: 'hotel',
    Object: 'value',
    span: 4
  }, {
    prop: 'hotel_room_policy',
    Object: 'value',
    span: 4
  }, {
    prop: 'start_date',
    span: 4
  }, {
    prop: 'end_date',
    span: 4
  }, {
    prop: 'room_count',
    span: 4
  }, {
    prop: 'payment_channel',
    span: 4
  }, {
    prop: 'created_at',
    span: 4
  }, {
    prop: 'paid_at',
    span: 4
  }],
  contact_information: [{
    prop: 'contact_name'
  }, {
    prop: 'contact_number'
  }, {
    prop: 'contact_dob'
  }, {
    prop: 'country_of_residence'
  }, {
    prop: 'email'
  }],
  customer_information: [{
    prop: 'customer_name'
  }, {
    prop: 'contact_number'
  }, {
    prop: 'customer_id'
  }, {
    prop: 'nickname'
  }, {
    prop: 'email'
  }]
}
